import React, { useState, useRef, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";
import { getListTicket, updateDataSearch } from "../../../actions/Ticket";
import { Headersubfull } from "../../GenericComponent/HeaderSubFull/headersubfull";
import userApi from "../../../service/userApi";
import { useSelector, useDispatch } from "react-redux";
import danhsachNhanVienApi from "service/danhSachNhanVienApi";
import DsCapPheDuyetApi from "../../../service/QuyTrinhPheDuyet/CapPheDuyet/dsCapPheDuyetApi";
import { pushNotification } from "utils/notifications";
import NumberField from "components/GenericComponent/NumberField";
import StoreApi from "../../../service/phanQuyenApi";
import LayoutV2 from "containers/LayoutV2";

export const PhanQuyenTaoChoDuyet = () => {
  const dispatch = useDispatch();
  const initDataAddAndEditnew = {
    UserName: null,
    CamDo_InChoDuyet: false,
    CamDo_ChoDuyetTheoLichSu: false,
    CamDo_ChoDuyetTheoHanMucGoiVay: false,
    CamDo_ChoDuyetTheoHanMuc: false,
    CamDo_ChoDuyetTheoHanMuc_HanMuc: 0,
    TinChap_InChoDuyet: false,
    TinChap_ChoDuyetTheoLichSu: false,
    TinChap_ChoDuyetTheoHanMucGoiVay: false,
    TinChap_ChoDuyetTheoHanMuc: false,
    TinChap_ChoDuyetTheoHanMuc_HanMuc: 0,
    TraGop_InChoDuyet: false,
    TraGop_ChoDuyetTheoLichSu: false,
    TraGop_ChoDuyetTheoHanMucGoiVay: false,
    TraGop_ChoDuyetTheoHanMuc: false,
    TraGop_ChoDuyetTheoHanMuc_HanMuc: 0,
  };

  const [dataRole, setDataRole] = useState({});
  const [lstNhanVien, setLstNhanVien] = useState(false);
  const [choisenNhanVien, setChoisenNhanVien] = useState(false);
  const initPhanQuyen = {
    quytrinhpheduyet_danhsach: false,
    quytrinhpheduyet_cappheduyet: false,
    quytrinhpheduyet_cauhinhchoduyet: false,
    quytrinhpheduyet_quanlygoivay: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  useEffect(() => {
    document.title =
      "Phân quyền tạo chờ duyệt | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
    userApi.getCurrentUser().then((res2) => {
      danhsachNhanVienApi
        .danhsach({
          email: "",
          phone: "",
          name: "",
          companyId: res2.data.CompanyID,
          pageIndex: 1,
          pageSize: 1000,
        })
        .then((response) => {
          if (response.status == "200") {
            setLstNhanVien(response.data.List);
            setChoisenNhanVien(response.data.List[0].Email);
            onSearch(response.data.List[0].Email);
          }
        });
    });
  }, []);
  const LoadPhanQuyen = () => {
    StoreApi.phanQuyenQuyTrinhPheDuyet().then((response) => {
      setPhanQuyen({
        ...phanQuyen,
        quytrinhpheduyet_danhsach: response.data.quytrinhpheduyet_danhsach,
        quytrinhpheduyet_cappheduyet:
          response.data.quytrinhpheduyet_cappheduyet,
        quytrinhpheduyet_cauhinhchoduyet:
          response.data.quytrinhpheduyet_cauhinhchoduyet,
        quytrinhpheduyet_quanlygoivay:
          response.data.quytrinhpheduyet_quanlygoivay,
      });
    });
  };
  const onChangeNhanVien = (field) => (e) => {
    setChoisenNhanVien(e.target.value);
    onSearch(e.target.value);
  };
  const onSearch = (user) => {
    DsCapPheDuyetApi.getQuyenChoDuyetByUserName({
      UserName: user,
    }).then((response) => {
      if (response.status == "200") {
        response.data.UserName = user;
        setDataRole(response.data);
      }
    });
  };
  const handleTextChange = () => (e) => {
    var data = { ...dataRole };
    data[e.target.id] = e.target.value;
    setDataRole(data);
  };

  const handleCheckChange = () => (e) => {
    var data = { ...dataRole };
    data[e.target.id] = e.target.checked;
    setDataRole(data);
  };
  const SaveQuyenChoDuyet = () => {
    DsCapPheDuyetApi.saveQuyenChoDuyetByUserName(dataRole).then((response) => {
      if (response.status === 200) {
        pushNotification("Thao tác thành công", "success", "TOP_CENTER", 2000);
      } else {
        pushNotification(response, "error", "TOP_CENTER", 2000);
      }
    });
  };
  return (
    <LayoutV2>
      {phanQuyen.quytrinhpheduyet_cauhinhchoduyet && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new mb-1">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          {/* <div className="col-sm-6"> */}
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-cam-do-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">
                            Phần quyền tạo chờ duyệt
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="card mb-3 border-light mb-1 card-v2"
              style={{
                marginLeft: "15px",
                marginRight: "15px",
              }}
            >
              <div className="card-body card-body-v2">
                <div
                  className="col-12"
                  style={{ marginLeft: 20, marginRight: 20 }}
                >
                  <div className="row">
                    <div className="input-sm-new input-new-25">
                      <label
                        htmlFor="customer-name"
                        className="font-color-default font-bold"
                      >
                        Tài khoản
                      </label>
                      <select
                        class="form-control input-sm"
                        value={choisenNhanVien}
                        onChange={onChangeNhanVien("choisenNhanVien")}
                      >
                        {lstNhanVien &&
                          lstNhanVien.map((item, idx) => (
                            <option key={"combo" + idx} value={item.Email}>
                              {item.Email}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div
                    className="row"
                    style={{ marginTop: 20, marginRight: 20 }}
                  >
                    <table className="table table-bordered mb-0 Table-main-new">
                      <thead>
                        <tr>
                          <th></th>
                          <th>
                            <span>Cầm đồ</span>
                          </th>
                          <th>
                            <span>Tín chấp</span>
                          </th>
                          <th>
                            <span>Trả góp</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <span>Quyền in chờ duyệt </span>
                          </td>
                          <td>
                            {" "}
                            <input
                              type="checkbox"
                              id="CamDo_InChoDuyet"
                              value={dataRole.CamDo_InChoDuyet}
                              checked={dataRole.CamDo_InChoDuyet}
                              onChange={handleCheckChange()}
                            ></input>
                          </td>
                          <td>
                            {" "}
                            <input
                              type="checkbox"
                              id="TinChap_InChoDuyet"
                              value={dataRole.TinChap_InChoDuyet}
                              checked={dataRole.TinChap_InChoDuyet}
                              onChange={handleCheckChange()}
                            ></input>
                          </td>
                          <td>
                            {" "}
                            <input
                              type="checkbox"
                              id="TraGop_InChoDuyet"
                              value={dataRole.TraGop_InChoDuyet}
                              checked={dataRole.TraGop_InChoDuyet}
                              onChange={handleCheckChange()}
                            ></input>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>Chờ duyệt theo lịch sử vay</span>
                          </td>
                          <td>
                            {" "}
                            <input
                              type="checkbox"
                              id="CamDo_ChoDuyetTheoLichSu"
                              value={dataRole.CamDo_ChoDuyetTheoLichSu}
                              checked={dataRole.CamDo_ChoDuyetTheoLichSu}
                              onChange={handleCheckChange()}
                            ></input>
                          </td>
                          <td>
                            {" "}
                            <input
                              type="checkbox"
                              id="TinChap_ChoDuyetTheoLichSu"
                              value={dataRole.TinChap_ChoDuyetTheoLichSu}
                              checked={dataRole.TinChap_ChoDuyetTheoLichSu}
                              onChange={handleCheckChange()}
                            ></input>
                          </td>
                          <td>
                            {" "}
                            <input
                              type="checkbox"
                              id="TraGop_ChoDuyetTheoLichSu"
                              value={dataRole.TraGop_ChoDuyetTheoLichSu}
                              checked={dataRole.TraGop_ChoDuyetTheoLichSu}
                              onChange={handleCheckChange()}
                            ></input>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>Chờ duyệt theo hạn mức gói</span>
                          </td>
                          <td>
                            {" "}
                            <input
                              type="checkbox"
                              id="CamDo_ChoDuyetTheoHanMucGoiVay"
                              value={dataRole.CamDo_ChoDuyetTheoHanMucGoiVay}
                              checked={dataRole.CamDo_ChoDuyetTheoHanMucGoiVay}
                              onChange={handleCheckChange()}
                            ></input>
                          </td>
                          <td>
                            {" "}
                            <input
                              type="checkbox"
                              id="TinChap_ChoDuyetTheoHanMucGoiVay"
                              value={dataRole.TinChap_ChoDuyetTheoHanMucGoiVay}
                              checked={
                                dataRole.TinChap_ChoDuyetTheoHanMucGoiVay
                              }
                              onChange={handleCheckChange()}
                            ></input>
                          </td>
                          <td>
                            {" "}
                            <input
                              type="checkbox"
                              id="TraGop_ChoDuyetTheoHanMucGoiVay"
                              value={dataRole.TraGop_ChoDuyetTheoHanMucGoiVay}
                              checked={dataRole.TraGop_ChoDuyetTheoHanMucGoiVay}
                              onChange={handleCheckChange()}
                            ></input>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>Chờ duyệt theo hạn mức cho phép</span>
                          </td>
                          <td>
                            {" "}
                            <input
                              type="checkbox"
                              id="CamDo_ChoDuyetTheoHanMuc"
                              value={dataRole.CamDo_ChoDuyetTheoHanMuc}
                              checked={dataRole.CamDo_ChoDuyetTheoHanMuc}
                              onChange={handleCheckChange()}
                            ></input>
                          </td>
                          <td>
                            {" "}
                            <input
                              type="checkbox"
                              id="TinChap_ChoDuyetTheoHanMuc"
                              value={dataRole.TinChap_ChoDuyetTheoHanMuc}
                              checked={dataRole.TinChap_ChoDuyetTheoHanMuc}
                              onChange={handleCheckChange()}
                            ></input>
                          </td>
                          <td>
                            {" "}
                            <input
                              type="checkbox"
                              id="TraGop_ChoDuyetTheoHanMuc"
                              value={dataRole.TraGop_ChoDuyetTheoHanMuc}
                              checked={dataRole.TraGop_ChoDuyetTheoHanMuc}
                              onChange={handleCheckChange()}
                            ></input>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span>Hạn mức cho phép</span>
                          </td>
                          <td>
                            <NumberField
                              className="form-control input-sm"
                              name={"CamDo_ChoDuyetTheoHanMuc_HanMuc"}
                              id={"CamDo_ChoDuyetTheoHanMuc_HanMuc"}
                              value={dataRole.CamDo_ChoDuyetTheoHanMuc_HanMuc}
                              onChange={handleTextChange()}
                            ></NumberField>
                          </td>
                          <td>
                            <NumberField
                              className="form-control input-sm"
                              name={"TinChap_ChoDuyetTheoHanMuc_HanMuc"}
                              id={"TinChap_ChoDuyetTheoHanMuc_HanMuc"}
                              value={dataRole.TinChap_ChoDuyetTheoHanMuc_HanMuc}
                              onChange={handleTextChange()}
                            ></NumberField>
                          </td>
                          <td>
                            <NumberField
                              className="form-control input-sm"
                              name={"TraGop_ChoDuyetTheoHanMuc_HanMuc"}
                              id={"TraGop_ChoDuyetTheoHanMuc_HanMuc"}
                              value={dataRole.TraGop_ChoDuyetTheoHanMuc_HanMuc}
                              onChange={handleTextChange()}
                            ></NumberField>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="card mb-3 border-light mb-1 card-v2"
              style={{
                marginLeft: "15px",
                marginRight: "15px",
              }}
            >
              <div className="card-body card-body-v2">
                <button
                  className="btn btn-new-main btn-checknew"
                  href={() => false}
                  onClick={SaveQuyenChoDuyet}
                  style={{
                    marginLeft: "15px",
                    marginRight: "15px",
                    float: "right",
                  }}
                >
                  <span>
                    <img src="/app-assets/images/icon-save-v2-white.png" />
                  </span>{" "}
                  Lưu phân quyền &nbsp;
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {!phanQuyen.quytrinhpheduyet_cauhinhchoduyet && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <Headersubfull
                  title="Phần quyền tạo chờ duyệt"
                  icon1="fas fa-donate"
                />
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
